import { PropsWithChildren } from "react";
import { Col, Row } from "reactstrap";

interface Props {
  className?: string;
}

export function StickyMainHeader({
  children,
  className,
}: PropsWithChildren<Props>) {
  const stickyHeaderClassName = className
    ? `sticky-top ${className}`
    : "sticky-top bg-light";

  return (
    <Row className={stickyHeaderClassName}>
      <Col>{children}</Col>
    </Row>
  );
}
